import Vue from 'vue'
const dingdingAuthorApi = {
  // 查询鉴权信息
  QUERY_DING_DING_AUTHOR_INFO: {
    url: 'xdap-admin/dingding/get/jsapiAuth',
    method: 'GET',
    disableSuccessMsg: true
  }
}
export function dingdingSdkInit() {
  // 加载钉钉sdk-js
  const ding = document.createElement('script')
  ding.type = 'text/javascript'
  ding.src = 'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js'
  const dingdingElement = document.body.appendChild(ding)
  const store = require('../../store/index.js')
  dingdingElement.onload = () => {
    const ddInfo = store.default.state.authModule.ddInfo
    var ddLoginDevingidineConfig = {}
    console.log('ddLoginDevingidineConfig', ddLoginDevingidineConfig)
    console.log('ddInfo', ddInfo)
    ddLoginDevingidineConfig.authUrl = window.location.href
    ddLoginDevingidineConfig.corpId = ddInfo && ddInfo.corpId
    // if (!ddLoginDevingidineConfig.corpId) {
    //   Vue.prototype.$message({
    //     type: 'error',
    //     message: `钉钉cropId获取失败，功能可能异常`
    //   })
    // }
    queryDingdingAuthorInfo(ddLoginDevingidineConfig).asyncThen((resp) => {
      console.log(window.location)
      console.log(resp)
      const dingdingConfig = {
        ...resp.data,
        type: 0,
        jsApiList: [
          'biz.user.get',
          'biz.ding.post',
          'biz.util.openLink',
          'biz.util.scan',
          'device.geolocation.get'
        ]
      }
      window.dd.config({
        ...dingdingConfig
      })
      console.log(window.dd)
      window.dd.error(function (err) {
        alert('dd error: ' + JSON.stringify(err))
      })
    }).asyncErrorCatch((err) => {
      console.log('err:', err)
    })
  }
}
// 钉钉扫码
export function dingdingScanQRCode(callback) {
  console.log(window.dd)
  window.dd.ready(() => {
    window.dd.biz.util.scan({
      type: 'all', // type 为 all、qrCode、barCode，默认是all。
      onSuccess: function (data) {
        // onSuccess将在扫码成功之后回调
        /* data结构
          { 'text': String}
        */
        var result = data.text
        callback({
          result
        })
      },
      onFail: function (err) {}
    })
  })
  window.dd.error((error) => {
    console.log('dd error: ' + JSON.stringify(error))
  })
}

// 钉钉定位
export function dingdingGetLocation(showMessage, callback) {
  console.log(window.dd)
  window.dd.ready(() => {
    window.dd.device.geolocation.get({
      targetAccuracy: 200,
      coordinate: 1,
      withReGeocode: false,
      useCache: true, // 默认是true，如果需要频繁获取地理位置，请设置false
      onSuccess: function (result) {
        /* result 结构 */
        console.log(result)
        var lat = result.latitude // 纬度，浮点数，范围为90 ~ -90
        var lng = result.longitude // 经度，浮点数，范围为180 ~ -180
        callback({
          lat,
          lng
        })
      },
      onFail: function (err) {
        if (showMessage) {
          Vue.prototype.$message({
            type: 'error',
            message: `钉钉定位失败，请稍后重试`
          })
        }
        callback()
        console.log('error', err)
      }
    })
  })
  window.dd.error((error) => {
    console.log('dd error: ' + JSON.stringify(error))
  })
}
function queryDingdingAuthorInfo(ddLoginDevingidineConfig) {
  const request = {
    ...dingdingAuthorApi.QUERY_DING_DING_AUTHOR_INFO
  }
  request['params'] = {
    corpId: ddLoginDevingidineConfig.corpId,
    authUrl: ddLoginDevingidineConfig.authUrl
  }
  return new Promise((resolve, reject) => {
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          console.log(resp)
          resolve(resp)
        },
        (error) => {
          reject(error)
        }
      )
      .asyncErrorCatch((error) => {
        reject(error)
      })
  })
}
